import {Environment} from "../enums/Environment";

export function buildHelmetTitle(baseTitle) {
    // Prepare
    const env = process.env.REACT_APP_ENV; // "dev", "staging" ou "prod"
    if (env === Environment.PROD || !env) {
        return baseTitle;
    }

    // Return
    return `[${env}] ${baseTitle}`;
}